import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './Button.css';

class Button extends Component {

  render() {
    const { text, active, onClick, className, id = false } = this.props;
    let style = {
      color: 'white',
      backgroundColor: '#364B5F',
    };

    if (active === false) {
      style.color = '#364B5F';
      style.backgroundColor = '#e6e6e6';
    }

    return (
      <div id={id} className={className !== undefined ? `underListButton ${className}` : 'underListButton'}
        onClick={active !== false ? onClick : undefined} style={style}>
        {text}
      </div>
    );
  }
}

export default translate()(Button);
